var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "m21.7 20.29-5.08-5.08a8.1 8.1 0 0 0 1.74-5.03c0-4.51-3.67-8.18-8.18-8.18S2 5.67 2 10.18s3.67 8.18 8.18 8.18c1.9 0 3.64-.65 5.03-1.74l5.08 5.08zm-11.53-3.93c-3.41 0-6.18-2.77-6.18-6.18S6.76 4 10.17 4s6.18 2.77 6.18 6.18-2.77 6.18-6.18 6.18"
  })));
};
export { SvgSearchIcon as Icon };
export default __webpack_public_path__ + "static/media/41ca59c70fc498f2b35565486a078d76.svg";